import {ID, Response} from '../../../../../../../_metronic/helpers'
export type User = {
  id?: ID
  name?: string
  avatar?: string
  email?: string
  username?: string
  firstname?: string
  lastname?: string
  position?: string
  role?: string
  last_login?: string
  two_steps?: boolean
  joined_day?: string
  online?: boolean
  initials?: {
    label: string
    state: string
  }
}

export type UsersQueryResponse = Response<Array<User>>

export const initialUser: User = {
  avatar: 'avatars/300-6.jpg',
  position: 'Art Director',
  role: 'Administrator',
  name: '',
  email: '',
}

export interface IUsers {
  id?: ID
  uuid?: string
  username?: string
  firstname?: string
  lastname?: string
  email?: string
  password?: string
  confirm_password?: string
  device_name?: string
}

export const UsersInitValues: IUsers = {
  username: '',
  firstname: '',
  lastname: '',
  email: '',
  password: '',
  confirm_password: '',
  device_name: '',
}

export interface IndemnityArea {
  id?: number
  uuid?: string
  years?: string
  indemnity_item?: {
    id?: number
    name?: string
    direct_damage_value?: string
    outgoing_profit_value?: string
    single_payment_value?: string
  }
  property_uuid?: string
  quantity?: string
  annual_servitude?: boolean
  single_servitude?: boolean
  direct_damage?: boolean
  business_interruption?: boolean
}

export type IndemnityAreaQueryResponse = Response<Array<IndemnityArea>>

export const IndemnityAreaInitValues: IndemnityArea = {
  years: '',
  annual_servitude: false,
  single_servitude: false,
  direct_damage: false,
  business_interruption: false,
}
